import * as THREE from "three";
import AppData from "../../../app.data";
import { Utils } from "../../../utils/utils";
import CameraService from "../../../services/camera/camera.service";
import Renderer from "../../../renderer/renderer";

const appData = new AppData();

export class SpaceProceduralManager {
    constructor(
        private utils: Utils,
        private cameraService: CameraService,
        private renderer: Renderer
    ) {}

    public handleProceduralSpace() {
        // add userData so we can target them in event service
        appData.spaceScene.traverse((child: any) => {
            if (child.name.includes("entryTo_")) {
                let str = child.name.split("_").pop();
                let index = str.indexOf("-SAFE-");
                let rezultat = index !== -1 ? str.slice(0, index) : str;

                let spaceNumber = rezultat.split("-").pop();
                let spaceNumberFormtted = Number(spaceNumber) - 1;

                child.userData = {
                    isActionToNextSpace: true,
                    makeVisibleSpace: rezultat,
                    parent: appData.spaceScene.getObjectByName(rezultat),
                    makeVisibleSpaceID: spaceNumberFormtted
                };

            } else if (child.name.includes("remove_")) {
                let str = child.name.split("_").pop();

                let spaceNumber = str.split("-").pop();
                let spaceNumberFormtted = Number(spaceNumber) - 1;

                child.userData = {
                    isActionToRemoveSpace: true,
                    spaceToRemove: str,
                    spaceToRemoveID: spaceNumberFormtted
                };

            } else if (child.name.startsWith("Space-")) {
                let spaceNumber = child.name.split("-").pop();
                let spaceNumberFormtted = Number(spaceNumber) - 1;

                child.userData.spaceID = spaceNumberFormtted;
            }
        });

        // hide entryPoints that open next space.Get the name of the next space from that entryPoijnt, verify if that space is visible and set it
        // force it to be queued last
        setTimeout(() => {
            this.utils.handleProceduralSpaceVisibility(appData);
            this.getRemoveIconsForEditors(appData);
            this.cameraService.hideRemoveIconsForEditors();
            this.renderer.addToRenderQueue();
        }, 100);
    }

    private getRemoveIconsForEditors(appData: any) {
        if (appData.galleryData.editable) {
            const removeIcons: any[] = [];
            appData.spaceScene.traverse((child: any) => {
                if (child.name.includes("remove_Space")) {
                    var target = new THREE.Vector3(); // create once an reuse it
                    child.getWorldPosition(target);
                    child.userData.realWorldPosition = target;
                    removeIcons.push(child);
                }
            });

            this.cameraService.collectRemoveIcons(removeIcons);
        }
    }
}

